import type { IEntraId, ILoginResponse, IMFAResponse, ISecurlyPassword, IUser } from '@/types/Data'
import type {
  ICheckMFA,
  IGetIsSecurlyPassword,
  IGetUserList,
  IGetUserListByFilter,
  ILogin,
  IPaging,
  IRenewPassword,
  IResetPassword,
  ISendActivationMessage,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class UserServices extends BaseService {
  GetUserList(payload: IGetUserList) {
    return this.GET<IUser[]>(this.PATHS.GET_USER_LIST, payload)
  }

  GetUserListByFilter(payload: IGetUserListByFilter) {
    return this.GET<IUser[]>(this.PATHS.GET_USER_LIST_BY_FILTER, payload)
  }

  SendActivationMessage(payload: ISendActivationMessage) {
    return this.POST<void>(this.PATHS.SEND_ACTIVATION_MESSAGE, payload)
  }

  ResetPassword(data: IResetPassword) {
    return this.POST<void>(this.PATHS.RESET_PASSWORD, data)
  }

  RenewPassword(data: IRenewPassword) {
    return this.POST<void>(this.PATHS.RENEW_PASSWORD, data)
  }

  GetIsSecurlyPassword(payload: IGetIsSecurlyPassword) {
    return this.GET<ISecurlyPassword>(this.PATHS.GET_IS_SECURELY_PASSWORD, payload)
  }

  MFACheck(payload: ICheckMFA) {
    return this.GET<IMFAResponse>(this.PATHS.MFA_CHECK, payload)
  }

  GetEntraId(CompanyCode: string) {
    return this.GET<IEntraId>(this.PATHS.GET_ENTRA_ID, { CompanyCode })
  }

  GetUserListReportExcel(data: IPaging) {
    return this.EXCEL(this.PATHS.GET_USER_LIST_EXCEL, true, data)
  }

  GetActiveUserCount() {
    return this.GET<number>(this.PATHS.GET_ACTIVE_USER_COUNT)
  }

  Login(payload: ILogin) {
    return this.POST<ILoginResponse>(this.PATHS.LOGIN, { ...payload, Platform: 'Admin' })
  }

  Logout(Id: string) {
    return this.POST<void>(this.PATHS.LOGOUT, { Id }, null, false)
  }

  RefreshToken(RefreshToken: string) {
    return this.POST<ILoginResponse>(this.PATHS.REFRESH_TOKEN, { RefreshToken, Platform: 'Admin' })
  }

  GetResetPasswordLink(targetUserId: string) {
    return this.GET<string>(this.PATHS.GET_RESET_PASSWORD_LINK, { targetUserId })
  }
}
